export default {
  // Componente visual - sem strings de texto traduzíveis
}
